import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

const menuItems = [
    { menuId: 1, menuName: 'Dashboard', iconsName: 'bi bi-house-door', routePath: "/dashboard" },
    { menuId: 2, menuName: 'Physical Stock', iconsName: 'bi bi-file-text', routePath: "/variation" },
    { menuId: 3, menuName: 'Kitchen Closing', iconsName: 'bi bi-file-text', routePath: "/kitchenclosing" },
    { menuId: 4, menuName: 'Kitchen Wastage', iconsName: 'bi bi-file-text', routePath: "/kitchenwastage" },
    { menuId: 5, menuName: 'Inter Department Transfer', iconsName: 'bi bi-file-text', routePath: "/interdepartmenttransfer" },
];

export default class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loggedIn: false,
            active: "dashboard",
            clickDisabled: false
        };
    }

    handleMenuClick = (menuName, routePath, e) => {
        if (this.state.clickDisabled) {
            e.preventDefault(); // Prevent navigation
            return;
        }

        this.setState({ clickDisabled: true, active: menuName });

        // Optional: Add a small delay to simulate/allow loading
        setTimeout(() => {
            this.setState({ clickDisabled: false });
        }, 1000); // You can adjust the timeout duration based on load time
    };

    render() {
        return (
            <footer ref={this.props.footerRef} className="footer">
                <div className="container">
                    <ul className="nav nav-pills nav-justified">
                        {
                            menuItems.map(mnuItem => (
                                <li key={mnuItem.menuId} className="nav-item">
                                    <NavLink
                                        className="nav-link"
                                        to={mnuItem.routePath}
                                        onClick={(e) => this.handleMenuClick(mnuItem.menuName, mnuItem.routePath, e)}
                                    >
                                        <span>
                                            <i className={"nav-icon " + mnuItem.iconsName}></i>
                                            <span className="nav-text">{mnuItem.menuName}</span>
                                        </span>
                                    </NavLink>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </footer>
        );
    }
}
